import type { HqMonthlyMeetingDraft, HqMonthlyMeetingDocument } from '@kop/contracts';

export type MeetingEditor = { meetingId: string; version: number; draft: HqMonthlyMeetingDraft };
export const meetingStatusLabel = (status: HqMonthlyMeetingDraft['status']) =>
  ({ draft: '작성 중', completed: '회의 완료', cancelled: '취소' })[status];

export function newMeetingEditor(
  year: number,
  month: number,
  reference?: {
    id: string;
    title: string;
    round: number | null;
    meetingDate: string | null;
  },
): MeetingEditor {
  return {
    meetingId: `hq-meeting-${crypto.randomUUID()}`,
    version: 0,
    draft: {
      year,
      month,
      round: reference?.round ?? null,
      title: reference ? `${reference.title} 보완 기록` : `${year}년 ${month}월 안전보건 월회의`,
      meetingDate: reference?.meetingDate ?? null,
      startsAt: null,
      location: '',
      facilitator: '',
      attendees: [],
      agenda: [],
      minutes: '',
      attachments: [],
      historicalReferenceId: reference?.id ?? null,
      status: 'draft',
    },
  };
}

export function editSavedMeeting(document: HqMonthlyMeetingDocument): MeetingEditor {
  return {
    meetingId: document.meetingId,
    version: document.version,
    draft: structuredClone(document.draft),
  };
}

export function meetingValidationMessage(path: readonly PropertyKey[], completed: boolean): string {
  if (path[0] === 'title') return '회의명을 입력해 주세요.';
  if (path[0] === 'meetingDate') return '회의일을 선택한 연·월에 맞춰 주세요.';
  if (path[0] === 'attendees') return '참석자 성명을 입력해 주세요.';
  if (path[0] === 'agenda') return '안건 제목과 입력한 일자를 확인해 주세요.';
  if (path[0] === 'attachments')
    return '첨부 자료를 확인해 주세요. 최대 30개까지 등록할 수 있습니다.';
  if (completed) return '회의 완료로 저장하려면 회의일과 회의록을 입력해 주세요.';
  return '입력한 회의 정보를 확인해 주세요.';
}

export function safeMeetingFileName(value: string) {
  return (
    Array.from(value, (character) => (character.charCodeAt(0) < 32 ? '_' : character))
      .join('')
      .replace(/[\\/]/gu, '_')
      .slice(0, 240) || '첨부자료'
  );
}
